import { Component, ViewEncapsulation, OnInit, AfterViewInit } from '@angular/core';
import { Route, Router } from '@angular/router';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';
import { GlobalStateService } from 'src/app/services/global/global-state.service';
declare var KTMenu: any;

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReportComponent extends DestructorComponent implements OnInit, AfterViewInit {

  // Navigation tabs
  activeTab: string = '';
  reportDataChildren: Route[] = [];
  masterDataChildren: Route[] = [];
  user: any;

  constructor(
    private router: Router,
    private _globalStateService: GlobalStateService
  ) {
    super();
  }

  // ngOnInit(): void {
  //   // Set initial active tab based on current route
  //   // this.setActiveTabFromRoute();

  // }

  ngOnInit(): void {
    // Find the master-data route first
    const masterDataRoute = this.router.config.find(r => r.path === 'sales');

    // Then find the 'other' child route within master-data
    const otherRoute = masterDataRoute?.children?.find(child => child.path === 'report');

    // Get the third-level children (auction-hall, documents, etc.)
    this.reportDataChildren = otherRoute?.children ?? [];

    this.subscriptions.push(
      this._globalStateService.user.subscribe(user => {
        this.user = user;

        if (this.user?.role_complete.is_admin) {
          this.reportDataChildren = otherRoute?.children ?? [];
        }
        else {
          console.log("permission ;;--->", this.user?.role_complete.permissions['report'])
          this.reportDataChildren = this.reportDataChildren.filter((child: any) => {
            return this.user?.role_complete.permissions['report'] && this.user?.role_complete.permissions['report'][child.path];
          });
        }
      })
    );
  }

  ngAfterViewInit(): void {
    // Initialize KTMenu instances for dropdown menus
    this.initializeMenus();
  }

  // Initialize KTMenu instances
  initializeMenus(): void {
    setTimeout(() => {
      if (typeof KTMenu !== 'undefined') {
        KTMenu.createInstances();
      }
    }, 100);
  }

  // Set active tab based on current route
  setActiveTabFromRoute(): void {
    const currentUrl = this.router.url;
    if (currentUrl.includes('/ar_ap')) {
      this.activeTab = 'arap';
    } else if (currentUrl.includes('/sales')) {
      this.activeTab = 'sales';
    } else if (currentUrl.includes('/pending_invoices')) {
      this.activeTab = 'pending';
    } else {
      // this.activeTab = 'arap'; // default
    }
  }

  // Navigation tab methods
  setActiveTab(tab: string): void {
    this.activeTab = tab;

    // Navigate to the appropriate route
    switch (tab) {
      case 'ar-ap':
        this.router.navigate(['/sales/report/ar-ap']);
        break;
      case 'sales':
        this.router.navigate(['/sales/report/sales']);
        break;
      case 'pending-invoices':
        this.router.navigate(['/sales/report/pending-invoices']);
        break;
      default:
        this.router.navigate(['/sales/report/ar-ap']);
    }
  }
}
